import { history } from "@state";
import { DefaultPath } from "./defaultRoutePathsEnum";

export const retryWithLastVisitedUrl = () => {
	const parseQuerySearchParams = new URLSearchParams(window.location.search);

	if (window.navigator.onLine) {
		history.replace(
			parseQuerySearchParams.get("lastVisitedUrl") || DefaultPath.HOME
		);
		return;
	}

	window.location.href =
		parseQuerySearchParams.get("lastVisitedUrl") || DefaultPath.HOME;
};
